import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

import "/assets/js/product/product-testimonial-slider.js";
import courseBooking from "./product/course-booking";

courseBooking();
